@app.directive 'csContent', ($sce, $filter, $compile, $sanitize) ->
  restrict: 'A',
  scope: {
    csContent: '='
    containerData: '='
    trustUnsanitized: '='
    stripOuterParagraph: '@'
  },

  link: (scope, element, attrs) ->
    scope.$watch 'csContent', (input) ->
      # Run markdown and shortcode filters.
      input = $filter('markdown')($filter('shortcode')(input))


      # Sanitize by default unless a parent specially promises this is safe.
      # This lets us do things like embed mailchimp signup forms or random other
      # scripts we might want to test.
      input = $sanitize(input) unless scope.trustUnsanitized

      input = angular.element(input).html() if scope.stripOuterParagraph and input
      element.html input

      # Compile the result in case shortcode or content
      # contained directives.
      $compile(element.contents()) scope
